import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { API_URL } from '../../../config';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';



const useStyles = makeStyles(() => ({
    customTooltip: {
        backgroundColor: "black",
        fontSize: "15px"
    }
}));

const ChangeDistributor6 = ({ deviceid, distributor, changeDistributorToggleModal, godevicelist, successechangedeviceModal, handleDistList, deviceCount}) => {

    const classes = useStyles();
    const navigation = useNavigate();
    const location = useLocation()

    const [editdata, setEditdata] = useState([]);
    const [changeDistId6, setChangeDistId6 ] = useState('');

    const [checkboxshow, setCheckboxshow] = useState(false)
    const [cmoduleval, setCmoduleval] = useState(0)
    const [mmoduleval, setMmoduleval] = useState(0)
    const [errorMessege, setErrorMessege] = useState(false);
    const [devicetype, setDevicetype] = useState(0)
    const [checkingboxmessge, setCheckingboxmessge] = useState(false);
    const [GoPersonaldefaultdata, setGoPersonaldefaultdata] = useState(5)
    const [data, setData ] = useState('');
    const [successeditdeviceModal6, setSuccesseditdeviceModal6] = useState(false);
    const successeditdeviceToggleModal6 = () => setSuccesseditdeviceModal6(!successeditdeviceModal6);



    useEffect(() => {
        getEditList6()


    }, [])



    const HandleEditdeviceType6 = (e)=>{
        setChangeDistId6(e.target.value);
        setErrorMessege(false)
    }

    const getEditList6 = () => {


        fetch(API_URL + "/get/all/distributer",
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',

                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    setData(resp.data)
                   
                    
                });
            }



        })
    }
   


    const editDevice6 = () => {
        let changeDist = {}
        // changeDist['transfer_distributer'] = changeDistId6;
        if(changeDistId6 == ""){
            setErrorMessege(true);
            return false
                    }else{
                    changeDist['transfer_distributer'] = changeDistId6;
                    }
        fetch(API_URL + "/transfer/distributer/six/by/" + deviceid, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',

            },
            body: JSON.stringify(changeDist)
        }).then((response) => {

            if (response.status == 200) {
                response.json().then((resp) => {
                    changeDistributorToggleModal()
                     successechangedeviceModal()
                     if (deviceCount == 1) {
                        setTimeout(() => {
                               navigation(`${location.pathname}` + "?dist=" + "all");
                           }, 3000);
   
                       }
                       else {
                           handleDistList()
                           godevicelist();
   
                       }
                });
            } else if (response.status == 400) {
                devicekeyToggleModal();
            }
            else {
                alert("network error")
            }

        })

    }




    return (
        <div>
            <ul className='deviceformlist'>
                <li>
                    <div className='select-device-type'>
                                    <select onChange={HandleEditdeviceType6}>
                                        <option value="">Select distributor</option>
                                        {
                                        data.length > 0 &&
                                        data?.map((item)=>{
                                            if((item.firstname == '')||(item.lastname == '')|| (item.firstname == null)||(item.lastname == null)){

                                            }else{
                                            return (
                                                <option value={item.eid} selected={item.eid == distributor ? "selected":''} >{item.firstname} {item.lastname}</option>
                                            )
                                            }
                                        })
                                    }
                                    </select>
                                </div>
                                {
                        errorMessege && <p className='error-message'>Field required </p>
                    }

                </li>

                <li>
                    <div className='addBtn'>
                        <button onClick={editDevice6}>Update</button>
                    </div>
                </li>

            </ul>

        </div>
    )
}

export default ChangeDistributor6;